import { Injectable } from '@angular/core';
import { LegacyBaseApiService } from '@smartera/core';
import { Urls } from '@core/config/urls';
import { ExportRequestData } from '../models/excel-export';
import { Observable } from 'rxjs';
import { AsyncOperationData } from '@api/models/general/async-operation-data';

@Injectable()
export class ReportResultExcelExportService extends LegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/analytic/report/export/excel/widgets';
	}

	export(data: ExportRequestData): Observable<AsyncOperationData> {
		return this._restClientService.post(`${this.apiUrl}/async-export`, JSON.stringify(data));
	}
}
